import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';

export const ProductModificationDoneComponent: FC = () => (
  <div className="w-100 alert alert-discreet-info d-flex mb-0 px-0" data-e2e="product-modification-done">
    <div className="card-body">
      <div className="fw-semibold align-middle">
        <FormattedMessage id="productModification.sidePanel.status.success" />
      </div>
    </div>
  </div>
);

ProductModificationDoneComponent.displayName = 'ProductModificationDoneComponent';
